import AnalyzeIcon from "@/components/ui/OpticksIcons/AnalyzeIcon";
import PointerIcon from "@/components/ui/OpticksIcons/PointerIcon";
import UserIcon from "@/components/ui/OpticksIcons/UserIcon";
import ChartFunnelIcon from "@/components/ui/OpticksIcons/ChartFunnelIcon";
import BellIcon from "@/components/ui/OpticksIcons/BellIcon";
import MessagesIcon from "@/components/ui/OpticksIcons/MessagesIcon";
import UsersIcon from "@/components/ui/OpticksIcons/UsersIcon";
import PlusCircleIcon from "@/components/ui/OpticksIcons/PlusCircleIcon";
import ShieldIcon from "@/components/ui/OpticksIcons/ShieldIcon";
import DashboardIcon from "@/components/ui/OpticksIcons/DashboardIcon";
import HandClickIcon from "@/components/ui/OpticksIcons/HandClickIcon";
import ReportIcon from "@/components/ui/OpticksIcons/ReportIcon";
import ApiIcon from "@/components/ui/OpticksIcons/ApiIcon";
import ShieldCheckIcon from "@/components/ui/OpticksIcons/ShieldCheckIcon";
import type { PlanExtension } from "@/types/model/Plan";
import OpticksPlanPillIndicator from "@/components/ui/OpticksPlanPillIndicator/OpticksPlanPillIndicator";
import GoogleAdsIcon from "@/components/ui/OpticksIcons/GoogleAdsIcon";
import MetaIcon from "@/components/ui/OpticksIcons/MetaIcon";
import MicrosoftIcon from "@/components/ui/OpticksIcons/MicrosoftIcon";
import TikTokIcon from "@/components/ui/OpticksIcons/TikTokIcon";
import MagnetIcon from "@/components/ui/OpticksIcons/MagnetIcon";
import OpticksChip from "@/components/ui/OpticksChip/OpticksChip";

export const plansDataExtension: { [k: string]: PlanExtension } = {
  lite: {
    type: "lite",
    typePill: "lite",
    order: 1,
    title: "Learn everything about the quality of your traffic",
    features: [
      {
        title: "Up to 10k monthly scans",
        icon: <PointerIcon />,
      },
      { title: "1 user", icon: <UserIcon /> },
      { title: "Detection only", icon: <ShieldIcon /> },
      {
        title: "Real-time Analytics for all your traffic channels",
        icon: <AnalyzeIcon />,
      },
      { title: "Conversion analysis", icon: <ChartFunnelIcon /> },
      { title: "Custom Alerts and Watchlist", icon: <BellIcon /> },
      { title: "Email and Chat support", icon: <MessagesIcon /> },
      {
        title: "Evaluate and monitor the quality of your incoming leads",
        icon: <MagnetIcon />,
        badge: (
          <OpticksChip label="NEW FEATURE" variation="impact-info" size="xs" />
        ),
      },
    ],
  },
  pro: {
    type: "pro",
    typePill: "pro",
    order: 2,
    title:
      "Automate prevention of invalid traffic in your advertising channels",
    features: [
      {
        title: "Up to 100k monthly scans",
        icon: <PointerIcon />,
      },
      { title: "5 users", icon: <UsersIcon /> },
      {
        title: "Detection and Prevention",
        icon: <ShieldCheckIcon />,
      },
      {
        title: (
          <span className="pricing-widget-feature-title">
            Everything in{" "}
            <OpticksPlanPillIndicator
              planType="lite"
              display="inline"
              height={20}
            />
            , plus:
          </span>
        ),
        icon: <PlusCircleIcon />,
      },
      {
        title: (
          <span className="pricing-widget-feature-title">
            Automated prevention in all supported channels:{" "}
            <GoogleAdsIcon size={20} /> <MetaIcon size={20} />{" "}
            <MicrosoftIcon size={20} /> <TikTokIcon size={20} />
          </span>
        ),
        icon: <ShieldIcon />,
      },
      {
        title: "Performance and Benchmark dashboards",
        icon: <DashboardIcon />,
      },
      {
        title: "Detailed Forensics for each scan",
        icon: <HandClickIcon />,
      },
    ],
  },
  max: {
    type: "max",
    typePill: "max",
    order: 3,
    title: "For businesses with advertising budgets up to 300k scans/month",
    features: [
      {
        title: "Up to 300k monthly scans",
        icon: <PointerIcon />,
      },
      { title: "10 users", icon: <UsersIcon /> },
      {
        title: "Detection and Prevention",
        icon: <ShieldCheckIcon />,
      },
      {
        title: (
          <span className="pricing-widget-feature-title">
            Everything in{" "}
            <OpticksPlanPillIndicator
              planType="lite"
              display="inline"
              height={20}
            />{" "}
            and{" "}
            <OpticksPlanPillIndicator
              planType="pro"
              display="inline"
              height={20}
            />
            , plus:
          </span>
        ),
        icon: <PlusCircleIcon />,
      },
      {
        title: "Custom click-by-click Reports",
        icon: <ReportIcon />,
      },
      { title: "API integration", icon: <ApiIcon /> },
    ],
  },
};
